import { computed, type ComputedRef } from 'vue'

import { useFeatureFlags, useRbac } from '@/features/account'

export interface WorkflowAccess {
  canAccess: ComputedRef<boolean>
  isSysAdmin: ComputedRef<boolean>
  isWorkflowEnabled: ComputedRef<boolean>
}

/** Exact production predicate: server-authored sysadmin OR workspace `workflow` flag. */
export function useWorkflowRbac(): WorkflowAccess {
  const { isSysAdmin } = useRbac()
  const { checkFlag } = useFeatureFlags()
  const isWorkflowEnabled = computed(() => checkFlag('workflow'))
  return {
    canAccess: computed(() => isSysAdmin.value || isWorkflowEnabled.value),
    isSysAdmin,
    isWorkflowEnabled,
  }
}
